import reactMapGlMaps from './reactmapgl';

export default { ...reactMapGlMaps };
